import { useCallback } from 'react';
import { useIntl, defineMessages } from 'react-intl';

import { NotificationService, NOTIFICATION_TYPE_SUCCESS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';
import * as LtlApi from '@shipstation/client-common/api/ltl.api';

const messages = defineMessages({
  inProgress: {
    id: 'uJyYf9',
    description: 'Notification shown while a booked freight void is in progress',
    defaultMessage: 'Voiding freight booking...',
  },
  success: {
    id: 'BReDQn',
    description: 'Notification shown after a booked freight booking is successfully voided',
    defaultMessage: 'Freight booking voided.',
  },
  error: {
    id: 'WSVh6D',
    description: 'Notification shown when a booked freight void fails',
    defaultMessage: 'Failed to void freight booking.',
  },
});

export const useVoidFreight = () => {
  const intl = useIntl();

  return useCallback(
    async (fulfillmentPlanIds: string[]) => {
      const notificationId = NotificationService.showNotification({
        title: intl.formatMessage(messages.inProgress),
        dontHide: true,
      });

      try {
        const data = await LtlApi.voidFreight({ fulfillmentPlanIds });

        if (!data.allSucceeded) {
          const failedResult = data.results.find((r) => !r.success);
          const errorMessage = failedResult?.errorMessage ?? intl.formatMessage(messages.error);
          NotificationService.updateNotification(notificationId, {
            title: intl.formatMessage(messages.error),
            content: errorMessage,
            notificationType: NOTIFICATION_TYPE_ERROR,
            dontHide: false,
          });
          return false;
        }

        NotificationService.updateNotification(notificationId, {
          title: intl.formatMessage(messages.success),
          notificationType: NOTIFICATION_TYPE_SUCCESS,
          dontHide: false,
        });
        return true;
      } catch (err) {
        const errorMessage =
          (err as { response?: { data?: { message?: string } } })?.response?.data?.message ?? intl.formatMessage(messages.error);
        NotificationService.updateNotification(notificationId, {
          title: intl.formatMessage(messages.error),
          content: errorMessage,
          notificationType: NOTIFICATION_TYPE_ERROR,
          dontHide: false,
        });
        return false;
      }
    },
    [intl],
  );
};
